import {
  BRANCH_TAG_LIST,
  FETCH_API_LOG,
  FETCH_API_NAMES,
  LOAN_APP_LOG_DETAIL_LIST,
  LOAN_APP_LOG_LIST,
  TAB_STAGE_VAL,
} from '../../resources/endPoint';

export const fetchApiLogDetails = data => {
  return {
    url: FETCH_API_LOG,
    payload: data,
    method: 'post',
    tag: 'FETCH_API_LOG',
    headers: {'content-type': 'application/json'},
    authRequired: true,
    csrfToken: true,
    service: '',
  };
};
export const fetchApiName = data => {
  return {
    url: FETCH_API_NAMES,
    payload: data,
    method: 'post',
    tag: 'FETCH_API_NAMES',
    headers: {'content-type': 'application/json'},
    authRequired: true,
    csrfToken: true,
    service: '',
  };
};
export const fetchLoanAppLog = data => {
  return {
    url: LOAN_APP_LOG_LIST,
    payload: data,
    method: 'post',
    tag: 'LOAN_APP_LOG_LIST',
    headers: {'content-type': 'application/json'},
    authRequired: true,
    csrfToken: true,
    service: '',
  };
};
export const fetchLoanAppLogDetail = data => {
  return {
    url: LOAN_APP_LOG_DETAIL_LIST,
    payload: data,
    method: 'post',
    tag: 'LOAN_APP_LOG_DETAIL_LIST',
    headers: {'content-type': 'application/json'},
    authRequired: true,
    csrfToken: true,
    service: '',
  };
};

export const fetchTabStageDetail = data => {
  return {
    url: TAB_STAGE_VAL,
    payload: data,
    method: 'post',
    tag: 'TAB_STAGE_VAL',
    headers: {'content-type': 'application/json'},
    authRequired: true,
    csrfToken: true,
    service: '',
  };
};
export const fetchBranchTagDetail = data => {
  return {
    url: BRANCH_TAG_LIST,
    payload: data,
    method: 'get',
    tag: 'BRANCH_TAG_LIST',
    headers: {'content-type': 'application/json'},
    authRequired: true,
    csrfToken: true,
    service: '',
  };
};
